import React, { useEffect } from "react";
import { useAppContext } from "../utils/context/app-context";
import { ContentContainer, TitleHeader } from "../components/UiComponents";
import { CourseTile } from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";

function UpcomingCoursesPage() {
	const { state, dispatch } = useAppContext();
	useDocumentTitle("Upcoming Courses");
	useEffect(() => {
		dispatch({type: 'SET_COURSE', payload: null})
	}, []);
	return (
		<div className="dashboard">
			<ContentContainer classes="mb-4">
				<TitleHeader title="Upcoming Courses" />
				{state.upcoming_courses.length > 0 ? (
					<div className="course-tiles">
						{state.upcoming_courses.map((course) => (
							<CourseTile course={course} key={course.id} showViewButton={false} />
						))}
					</div>
				) : (
					<p>You have no upcoming courses</p>
				)}
			</ContentContainer>
		</div>
	)
}

export default UpcomingCoursesPage;